import React, { useEffect, useState } from 'react';
import './QuestionAnswering.css';

function QuestionAnswering({ question, currentIndex, totalQuestions, onSelectAnswer, onPrevious, canGoPrevious }) {
  const progress = ((currentIndex + 1) / totalQuestions) * 100;
  const toPersianNumber = (number) => number.toLocaleString('fa-IR');
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    setSelectedOption(null);
  }, [question.id]);

  const selectAnswer = (optionValue) => {
    setSelectedOption(optionValue);
    onSelectAnswer(optionValue);
  };

  return (
    <div className="step-section stitch-create-step stitch-question-step">
      <div className="progress-container stitch-question-progress">
        <div className="stitch-progress-heading">
          <span className="stitch-progress-step">مرحله {toPersianNumber(currentIndex + 1)} از {toPersianNumber(totalQuestions)}</span>
          <strong className="stitch-progress-percent">{toPersianNumber(Math.round(progress))}٪ تکمیل شده</strong>
        </div>
        <div className="stitch-progress-track" aria-label={`پیشرفت ${Math.round(progress)} درصد`}>
          <div className="stitch-progress-value" style={{ width: `${progress}%` }} />
        </div>
      </div>

      <div className="question-card-single stitch-question-card">
        <div className="stitch-question-card-heading">
          <span className="stitch-question-number">{toPersianNumber(currentIndex + 1)}</span>
          <h2 className="question-text-large">{question.question_text}</h2>
        </div>
      </div>

      <div className="options-grid-large stitch-options-list" role="radiogroup" aria-label="گزینه‌های پاسخ">
        {question.options?.map((option) => {
          const isSelected = selectedOption === option.option_value;
          const optionText = option.emoji
            ? option.option_text.replace(option.emoji, '').trim()
            : option.option_text;

          return (
            <button
              key={option.option_value}
              className={`option-button-large stitch-answer-option${isSelected ? ' is-selected' : ''}`}
              onClick={() => selectAnswer(option.option_value)}
              type="button"
              role="radio"
              aria-checked={isSelected}
            >
              <span className="stitch-answer-main">
                {option.emoji && <span className="option-emoji">{option.emoji}</span>}
                <span className="option-text">{optionText}</span>
              </span>
              <span className="material-symbols-outlined stitch-answer-check" aria-hidden="true">check_circle</span>
            </button>
          );
        })}
      </div>

      {canGoPrevious && (
        <button className="btn-previous" onClick={onPrevious} type="button">
          سوال قبلی
        </button>
      )}

      <aside className="stitch-question-tip">
        <span className="material-symbols-outlined">tips_and_updates</span>
        <div>
          <h3>نکته برای ساخت آزمون</h3>
          <p>پاسخی را انتخاب کن که دوستات با کمی فکر بتوانند حدس بزنند و بازی جذاب بماند.</p>
        </div>
      </aside>
    </div>
  );
}

export default QuestionAnswering;
